var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-list-section');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityList } from './entity-list';
import { ContentSection } from '../elements/content-section';
import { MoreDivider } from '../elements/more-divider';
import { first, sortBy } from 'lodash';
import { entityPluralLabel } from '../../utils/entity-plural-label';
import { entityLabel } from '../../utils/entity-label';
import AnimateHeight from 'react-animate-height';
export var EntityListSectionDefaultProps = {
  orderBy: "name"
}; // -------- Child Component Props -------->
// -------- Styles -------->

var SectionStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme.UNIT(4), theme.UNIT(3))
});
var ListStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MoreStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: -", ";\n  "], ["\n    margin-top: -", ";\n  "])), theme.UNIT(2))
}); // -------- Components -------->

var My = {
  Section: styled(ContentSection)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  List: styled(EntityList)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  More: styled(MoreDivider)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), MoreStyles)
};
export var EntityListSection = function EntityListSection(props) {
  var className = props.className,
      showDivider = props.showDivider,
      maxItems = props.maxItems,
      orderBy = props.orderBy,
      listProps = __rest(props, ["className", "showDivider", "maxItems", "orderBy"]);

  var items = orderBy ? sortBy(props.items, orderBy) : props.items;

  var _a = __read(useState(false), 2),
      isExpanded = _a[0],
      setIsExpanded = _a[1];

  var itemsToShow = maxItems && !isExpanded ? items.slice(0, maxItems) : items;
  var moreCount = items.length - itemsToShow.length;
  var showMoreLink = moreCount > 0;

  if (!itemsToShow.length) {
    return null;
  }

  var firstItem = first(items);
  var autoTitle = entityLabel(firstItem);
  var autoPluralTitle = entityPluralLabel(firstItem);
  var useLinks = !!listProps.useLinks;
  var title = props.title === undefined ? autoTitle + ":" : props.title;
  var pluralTitle = props.pluralTitle === undefined ? autoPluralTitle + ":" : props.pluralTitle;
  return React.createElement(React.Fragment, null, React.createElement(My.Section, {
    showDivider: !showMoreLink,
    title: items.length === 1 ? title : pluralTitle,
    className: cls.name(className)
  }, React.createElement(AnimateHeight, {
    height: "auto"
  }, React.createElement(My.List, __assign({}, listProps, {
    useLinks: useLinks,
    items: itemsToShow
  })))), showMoreLink && React.createElement(My.More, {
    count: moreCount,
    onClick: function onClick(event) {
      event.stopPropagation();
      setIsExpanded(true);
    }
  }));
};
EntityListSection.defaultProps = EntityListSectionDefaultProps;
EntityListSection.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;